import { DOCUMENT } from '@angular/common'
import { Service, effect, inject, signal } from '@angular/core'

@Service()
export class ThemeService {
  readonly isDarkTheme = signal(false)

  constructor() {
    // On <html>, so dialogs and select panels (rendered outside the app root) switch too:
    // `.dark-theme` sets color-scheme: dark, which every light-dark() token follows.
    const root = inject(DOCUMENT).documentElement
    effect(() => root.classList.toggle('dark-theme', this.isDarkTheme()))
  }

  checkStorageForDarkTheme() {
    if (localStorage.getItem('isDarkMode') === 'true') {
      this.isDarkTheme.set(true)
    } else {
      this.isDarkTheme.set(false)
    }
  }

  setDarkTheme(isDarkTheme: boolean): void {
    localStorage.setItem('isDarkMode', isDarkTheme.toString())
    this.isDarkTheme.set(isDarkTheme)
  }
}
